import React from "react";
import { getInitials, normKey, stripYear, stripParens, buildInteriorSeq } from "../../utils/imageHelpers";

const COL_W = 110;
const IMG_W = 84;
const MOVIE_H = 126;
const ACTOR_H = 84;
const ARROW_W = 28;
const GAP = 12;
const LABEL_FS = 12;
const LABEL_LH = 1.2;
const LABEL_LINES = 2;
const LABEL_H = 30;

export function InteriorReelStrip({ reel, imagesByName = {} }) {
  if (!reel) return null;

  const normMap = {};
  for (const [k, v] of Object.entries(imagesByName || {})) {
    const a = normKey(k);
    normMap[a] = v;
    normMap[normKey(stripYear(k))] = v;
    normMap[normKey(stripParens(k))] = v;
  }

  const lookup = (name) =>
    imagesByName?.[name] ||
    imagesByName?.[stripYear(name)] ||
    imagesByName?.[stripParens(name)] ||
    normMap[normKey(name)] ||
    normMap[normKey(stripYear(name))] ||
    normMap[normKey(stripParens(name))];

  const seq = buildInteriorSeq(reel.actor_chain, reel.movie_chain);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: GAP,
        overflowX: "auto",
        padding: "8px 0",
      }}
    >
      {seq.length === 0 ? (
        <div className="opacity-60 text-sm">No interior steps</div>
      ) : (
        seq.map((node, idx) => {
          const meta = lookup(node.name);
          const imgUrl = node.type === "movie" ? meta?.poster_path : meta?.profile_path;
          const isMovie = node.type === "movie";

          return (
            <React.Fragment key={`${node.type}-${node.name}-${idx}`}>
              <div
                style={{
                  width: COL_W,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {imgUrl ? (
                  <img
                    src={imgUrl}
                    alt={node.name}
                    style={{
                      width: IMG_W,
                      height: isMovie ? MOVIE_H : ACTOR_H,
                      objectFit: "cover",
                      borderRadius: isMovie ? 10 : "50%",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    }}
                    loading="lazy"
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <div
                    style={{
                      width: IMG_W,
                      height: isMovie ? MOVIE_H : ACTOR_H,
                      borderRadius: isMovie ? 10 : "50%",
                      background: "#f0f0f0",
                      color: "#555",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                    title={node.name}
                  >
                    {getInitials(node.name)}
                  </div>
                )}

                <div
                  style={{
                    marginTop: 6,
                    fontSize: LABEL_FS,
                    lineHeight: LABEL_LH,
                    textAlign: "center",
                    width: "100%",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: LABEL_LINES,
                    WebkitBoxOrient: "vertical",
                    wordBreak: "break-word",
                    height: LABEL_H,
                    fontFamily: "'Montserrat', sans-serif",
                  }}
                  title={node.name}
                  aria-label={node.name}
                >
                  {node.name}
                </div>
              </div>

              {idx < seq.length - 1 && (
                <div
                  aria-hidden
                  style={{ width: ARROW_W, display: "flex", justifyContent: "center" }}
                >
                  <span style={{ fontSize: 18, opacity: 0.6, userSelect: "none" }}>→</span>
                </div>
              )}
            </React.Fragment>
          );
        })
      )}
    </div>
  );
}
